/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartAxes = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m5 1.586 3.707 3.707-1.414 1.414L6 5.414l-.001 12.585h12.586l-1.292-1.292 1.414-1.414L22.414 19l-3.707 3.707-1.414-1.414L18.585 20H4V5.415L2.707 6.707 1.293 5.293z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartAxes as ChartAxes };
